// NOTE: AUTO GENERATED FILE! Do not modify directly!

export enum CategoriesColorsEnum {
  'RED' = '#eb4747',
  'ORANGE' = '#fba353',
  'YELLOW' = '#ffda57',
  'LIGHT_GREEN' = '#c4e51a',
  'DARK_GREEN' = '#53c653',
  'TEAL' = '#5c9790',
  'TURQUOISE' = '#85e0d0',
  'LIGHT_BLUE' = '#42d4f4',
  'DARK_BLUE' = '#4982d8',
  'VIOLET' = '#8357db',
  'PURPLE' = '#df6ddf',
  'PINK' = '#ee90a8',
  'MAROON' = '#91251c',
  'BROWN' = '#926531',
  'KHAKI' = '#808026',
  'NAVY_BLUE' = '#009',
  'LIGHT_GREY' = '#a7b1be',
  'DARK_GREY' = '#4c5767'
}
